export const loaderModifierList = ['small', 'medium', 'light'];

export const wrapperModifierList = ['no-opacity', 'fixed'];
